import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../shared/common/common.service';
import { AuthService } from '../auth.service';

@Injectable()
export class DeveloperGuard {

  constructor(private authService: AuthService, 
    private commonService: CommonService, 
    private toastrService: ToastrService,
    private router: Router) { }

  canActivate() {
    if (this.authService.canAccessDeveloper()) {
      return true;
    }
    
    this.commonService.showLoader(false);
    this.toastrService.error("You are not authorized to access the Developer module.\n\nPlease contact IT for additional information.", "Unauthorized");
    this.router.navigate(['unauthorized']);
    return false;    
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/guards/developer-guard.service.ts